/**
 * Legacy particle system types for migration support.
 * These types match the old Unity Shuriken-derived format.
 * @deprecated Use ParticleSystemData from particledata.ts instead.
 */

import type { BehaviorData } from '../behaviordata';

/** @deprecated Use Range from particledata.ts */
export enum ParticleSystemCurveMode {
    Constant = "Constant",
    Curve = "Curve",
    TwoConstants = "TwoConstants",
    TwoCurves = "TwoCurves"
}

/** @deprecated */
export enum LegacyParticleSystemShapeType {
    Sphere = "Sphere",
    Hemisphere = "Hemisphere",
    Cone = "Cone",
    ConeVolume = "ConeVolume",
    Box = "Box",
    Rectangle = "Rectangle"
}

/** @deprecated Use Range from particledata.ts */
export interface LegacyMinMaxCurve {
    constant?: number;
    minValue?: number;
    maxValue?: number;
    scalar?: number;
    mode?: ParticleSystemCurveMode;
    customCurve?: Array<{ time: number; value: number; inTangent?: number; outTangent?: number }>;
}

/** @deprecated */
export enum LegacyGradientMode {
    Color = "Color",
    Gradient = "Gradient",
    TwoColors = "TwoColors",
    TwoGradients = "TwoGradients",
}

/** @deprecated Use ColorStop from particledata.ts */
export interface LegacyGradientAttributes {
    mode?: LegacyGradientMode;
    color?: string;
    minColor?: string;
    maxColor?: string;
}

/** @deprecated Use ParticleSystemData from particledata.ts */
export interface LegacyParticleSystemData extends BehaviorData {
    "@type": "ParticleSystem";
    emission: {
        rateOverTime: number;
        rateOverDistance: number;
        maxParticleCount: number;
    };
    shape: {
        type: LegacyParticleSystemShapeType;
        angle: number;
        radius?: number;
        scale?: [number, number, number];
        position?: [number, number, number];
        rotation: [number, number, number, number];
        randomPosition?: number;
    };
    size: {
        sizeAtStart: LegacyMinMaxCurve;
        sizeOverLifetime?: LegacyMinMaxCurve;
    };
    color: {
        colorAtStart: LegacyGradientAttributes;
        colorOverLifetime?: LegacyGradientAttributes;
    };
    physicsData: {
        simulationSpeed?: number;
        velocityAtStart?: LegacyMinMaxCurve;
        /** Rotation at start in radians (Unity stores radians) */
        rotationAtStart?: LegacyMinMaxCurve;
        /** Angular velocity in radians/sec (Unity stores radians) */
        angularVelocity?: LegacyMinMaxCurve;
    };
    lifetime: {
        lifetimeAtStart: LegacyMinMaxCurve;
    };
    gravity: {
        gravityModifier: number;
    };
    texture: {
        src: string;
        material?: string;
    };
    noiseData?: {
        enabled?: boolean;
        frequency?: number;
        octaves?: number;
        strength?: LegacyMinMaxCurve;
        strengthX?: LegacyMinMaxCurve;
        strengthY?: LegacyMinMaxCurve;
        strengthZ?: LegacyMinMaxCurve;
    };
}
